<template>
  <AppNavbar />
  <main>
    <HeroSection />
    <FeaturesSection />
    <ModesSection />
    <WeaponsSection />
    <DownloadSection />
  </main>
  <FooterSection />
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useHead } from '@vueuse/head'
import AppNavbar from './components/AppNavbar.vue'
import HeroSection from './components/HeroSection.vue'
import FeaturesSection from './components/FeaturesSection.vue'
import ModesSection from './components/ModesSection.vue'
import WeaponsSection from './components/WeaponsSection.vue'
import DownloadSection from './components/DownloadSection.vue'
import FooterSection from './components/FooterSection.vue'

const { locale } = useI18n()

// 根据当前语言动态更新页面 meta，便于搜索引擎与社交分享抓取
useHead(() => {
  const isZh = locale.value === 'zh'
  return {
    htmlAttrs: {
      lang: isZh ? 'zh-CN' : 'en'
    },
    title: isZh
      ? '蛟龙行动 Dragon Ops | 战术射击游戏官网'
      : 'Dragon Ops | Tactical Shooter Game Official Site',
    meta: [
      {
        name: 'description',
        content: isZh
          ? '蛟龙行动 Dragon Ops —— 一人闯关突破极限，红蓝方对战燃爆全场。FPS与TPS双模式自由切换，写实枪械手感、真实弹道模拟、战术配合制胜。支持 Windows / Android / iOS 免费下载。'
          : 'Break your limits in solo campaigns, or ignite the battlefield in Red vs. Blue warfare. Switch freely between FPS and TPS, experience realistic gun handling and authentic ballistics. Free on Windows, Android and iOS.'
      },
      { property: 'og:locale', content: isZh ? 'zh_CN' : 'en_US' },
      {
        property: 'og:title',
        content: isZh
          ? '蛟龙行动 Dragon Ops | 战术射击游戏官网'
          : 'Dragon Ops | Tactical Shooter Game Official Site'
      },
      {
        property: 'og:description',
        content: isZh
          ? '一人闯关突破极限，红蓝方对战燃爆全场。FPS与TPS双模式自由切换，写实枪械手感、真实弹道模拟、战术配合制胜。'
          : 'Break your limits in solo campaigns, or ignite the battlefield in Red vs. Blue warfare. FPS/TPS tactical shooter.'
      }
    ]
  }
})
</script>

<style>
:root {
  --accent: #ff6b35;
  --accent-hover: #ff7f50;
  --bg-light: #fff8f3;
  --text-dark: #2c1b18;
  --text-muted: #6b5f5a;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: 'Inter', 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  color: var(--text-dark);
  background: #fff;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}
</style>
